import React from "react";
import "./AllTask.css";
function AllTask({ authEmployeeData, setShowId, setAsignTo,setChartData }) {
  return (
    <div className="mytaskvarious">
      <div className="d-flex mytask">
        <span className="col-12">Employee Name</span>
      </div>
      {authEmployeeData.filter((e)=>e.role!=="admin").map((empData, index) => {
        return (
          <div
            className="d-flex mytasklist"
            key={index}
            onClick={() => {
              setShowId(empData.id);
              setAsignTo(empData.id);
              setChartData({
                labels: ["New", "Accepted", "Failed", "Success"],
                datasets: [
                  {
                    data: [
                      empData.taskCounts.newTask,
                      empData.taskCounts.active,
                      empData.taskCounts.failed,
                      empData.taskCounts.completed,
                    ],
                    backgroundColor: ["rgb(244, 181, 65)", "#6fa9fb", "tomato", "#61d977"], // Colors for each section
                    borderColor: ["#ffffff", "#ffffff", "#ffffff", "#ffffff"], // Border color (white here)
                    borderWidth: 2, // Border width for each section
                  },
                ],
              });
            }}
          >
            <span className="col-12">{empData.name}</span>
          </div>
        );
      })}
    </div>
  );
}

export default AllTask;
